import React, { FC } from 'react'

import { ReceiptItem } from '../ReceiptItem/ReceiptItem'

import { IRegistrationFeesInterface } from '../../../../models/registration-fees/registrationFees.interface'
import { ITotalPrices } from '../../../../helpers/payment'

interface ReceiptFeesListProps {
  fees?: { items: IRegistrationFeesInterface[]; totalPrice: ITotalPrices }
  type?: 'mandatory'
  currency: string
}

export const ReceiptFeesList: FC<ReceiptFeesListProps> = ({ fees, type, currency }) => {
  return (
    <div className="py-5">
      <h3 className="text-base font-semibold mb-3 break-inside-avoid">
        {type === 'mandatory' ? 'Mandatory Show Fees' : 'Show Fees'}
      </h3>
      <div className="space-y-2">
        {fees?.items?.map((item) => (
          <ReceiptItem
            key={item.id}
            title={item.feesTitle || 'N/A'}
            selectedCount={item.selectedUnitsCount || 0}
            price={item.feesPrice || 0}
            originalPrice={item.originalFeesPrice || 0}
            paidDate={item.paidDate || null}
            cardNo={item.cardNo}
            paymentType={item.paymentType}
            paymentStatus={item.paymentStatus}
            amountRefunded={item.amountRefunded}
            refundedDate={item.refundedDate || null || null}
            isRefunded={item.refundAmountAdded || false}
            isScratched={item.isScratched || false}
            scratchedDate={item.scratchedDate || null}
            ownerId={item.ownerId}
            ownerName={item.ownerName || null}
            recipientId={item.recipientId}
            recipientName={item.recipientName}
            currency={currency}
          />
        ))}
      </div>
    </div>
  )
}
